import React from 'react';


export const Terraform = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/terraform.png')} />
    )
};
